export default {
    getHeaderFields: state => state.headerFields,
    getSearchHeaderFields: state => state.searchHeaderFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    getDataTableOptions: state => state.dataTableOptions,
}
